import React, { useEffect, useState, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { FaAnglesLeft } from "react-icons/fa6";
import { FaAnglesRight } from "react-icons/fa6";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

import CryptoJS from 'crypto-js';

const Home = () => {
  const [data, setData] = useState("Not Found");
  const [uniqueIds, setUniqueIds] = useState("");
  const [encryptedText, setencryptedText] = useState("");
  const [isScanning, setIsScanning] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const [moveRight, setMoveRight] = useState(false);
  const [moveLeft1, setMoveLeft1] = useState(false);
  const [messageNew, setMessageNew] = useState("");
  const [messageNewError, setMessageNewError] = useState("");
  const [messageLeft, setMessageLeft] = useState("")
  const [messageLefterror, setMessageLefterror] = useState("")
  const [details, setDetails] = useState([])
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dimensions, setDimensions] = useState({ width: 640, height: 480 });

  // New state for draggable buttons
  const [isDraggingLeft, setIsDraggingLeft] = useState(false);
  const [isDraggingRight, setIsDraggingRight] = useState(false);
  const [dragPositionLeft, setDragPositionLeft] = useState(0);
  const [dragPositionRight, setDragPositionRight] = useState(0);
  const leftButtonRef = useRef(null);
  const rightButtonRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth < 768 ? 670 : 640,
        height: window.innerWidth < 768 ? 510 : 480,
      });
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const decryptUniqueId = (encryptedText) => {
    const secretKey = "MyS3cr3tK3yF2rEncrypT1on!1234567";

    if (!encryptedText || !encryptedText.includes(":")) {
      console.error("Invalid encrypted text format");
      return "";
    }

    const [ivHex, encryptedHex] = encryptedText.split(":");

    if (!ivHex || !encryptedHex) {
      console.error("Invalid encrypted text format: Missing IV or encrypted data");
      return "";
    }

    try {
      const iv = CryptoJS.enc.Hex.parse(ivHex);
      const encrypted = CryptoJS.enc.Hex.parse(encryptedHex);

      const decryptedBytes = CryptoJS.AES.decrypt(
        { ciphertext: encrypted },
        CryptoJS.enc.Utf8.parse(secretKey),
        { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
      );

      const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
      return decryptedText || "";
    } catch (error) {
      console.error("Decryption failed:", error);
      return "";
    }
  };

  useEffect(() => {
    if (encryptedText) {
      const decryptedText = decryptUniqueId(encryptedText);
      if (decryptedText && decryptedText !== uniqueIds) {
        setUniqueIds(decryptedText);
      }
    }
  }, [encryptedText]);

  const handleRequestLocation = () => {
    setLoading(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ latitude, longitude });
          getCityStateCountry(latitude, longitude);
        },
        (err) => {
          setError(err.message);
          setLoading(false);
          alert(`Error: ${err.message}`);
        }
      );
    } else {
      setError("Geolocation is not supported by this browser.");
      setLoading(false);
      alert("Geolocation is not supported by this browser.");
    }
  };

  const getCityStateCountry = async (lat, lon) => {
    try {
      const apiKey = "63b5ee1d87d049259757b4a408565081";
      const response = await axios.get(
        `https://api.opencagedata.com/geocode/v1/json?q=${lat}+${lon}&key=${apiKey}`
      );

      if (response.data.results.length > 0) {
        const result = response.data.results[0];
        const details = result.components;
        const formattedLocation = {
          address: result.formatted || "Unknown Address",
          area:
            details.suburb ||
            details.neighbourhood ||
            details.district ||
            "Unknown Area",
          city: details.city || details.town || details.village || "Unknown",
          state: details.state || "Unknown",
          country: details.country || "Unknown",
          postalCode: details.postcode || "N/A",
        };

        setLocation((prev) => ({ ...prev, ...formattedLocation }));
      } else {
        setError("No address found.");
      }
      setLoading(false);
    } catch (error) {
      setError("Failed to fetch address details.");
      setLoading(false);
    }
  };

  const newScan = () => {
    setLoading(true);

    const data = {
      unique_id: uniqueIds,
      location: location?.address,
      area: location?.area,
      city: location?.city,
      state: location?.state,
      country: location?.country,
      pincode: location?.postalCode,
    };

    axios.post(`${process.env.REACT_APP_BASE_URL}get_new_unique_scan`, data)
      .then((response) => {
        if (response.status === 200 && response.data?.result === "true") {
          setLoading(true)
          scanDetails();
          setMessageNew("");
          setMessageNewError("");
        } else {
          setMessageNew("");
          setMessageNewError("Already Sold or Not Verified or Expired");
        }
      })
      .catch((error) => {
        console.log("New Scan Error:", error);
        setMessageNew("");
        const msg = error?.response?.data?.msg;
        if (
          msg === "User already scanned this QR code." ||
          msg === "Invalid QR, please scan another QR."
        ) {
          setMessageNewError("Already Sold or Not Verified or Expired");
        } else {
          setMessageNewError("Already Sold or Not Verified or Expired");
        }

        if (error?.status === 400) {
          setDetails(null);
        }
      })
      .finally(() => setLoading(false));
  };

  const leftscan = () => {
    const data = {
      unique_id: uniqueIds,
      location: location?.address,
      area: location?.area,
      city: location?.city,
      state: location?.state,
      country: location?.country,
      pincode: location?.postalCode,
    };

    axios.post(`${process.env.REACT_APP_BASE_URL}get_new_unique_scan_left`, data)
      .then((response) => {
        if (response?.status === 200 && response?.data?.result === "true") {
          setMessageLeft("Congratulations!!");
          setMessageLefterror("");
        } else {
          setMessageLeft("");
          setMessageLefterror("Already Sold or Not Verified or Expired");
        }
      })
      .catch((error) => {
        setMessageLeft("");
        const msg = error?.response?.data?.msg;
        if (
          msg === "User already scanned this QR code." ||
          msg === "Invalid QR, please scan another QR."
        ) {
          setMessageLefterror("Already Sold or Not Verified or Expired");
        } else {
          setMessageLefterror("Already Sold or Not Verified or Expired");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const scanDetails = async () => {
    setLoading(true);

    const data = {
      unique_id: uniqueIds,
      location: location?.address,
      area: location?.area,
      city: location?.city,
      state: location?.state,
      country: location?.country,
      pincode: location?.pincode,
    };

    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}get_new_unique_scan_right`, data);
      console.log("Scan Response:", response);
      setDetails(response?.data?.data?.table_data || []);
    } catch (error) {
      console.log("Error:", error);
      if (error?.response?.data) {
        const errorMessage = error.response.data.msg;
        console.error("Error Message:", errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleclose2 = () => {
    setIsModalOpen(false);
    setencryptedText("");
    setUniqueIds("");
    setDetails(null);
    setIsScanning(false);
    setIsOpen(false);
    setMessageLeft("");
    setMessageLefterror("");
    setLoading(false);
    // Reset buttons when closing modal
    resetButtons();
  };

  const handleclose3 = () => {
    setIsModalOpen3(false)
    setencryptedText("")
    setUniqueIds("")
    setDetails(null)
    setIsScanning(false)
    setIsOpen(false)
    // Reset buttons when closing modal
    resetButtons();
  }

  const handlecameraOpen = () => {
    setencryptedText("")
    setUniqueIds("")
    setDetails(null)
    setIsScanning(true)
    // Reset buttons when opening camera
    resetButtons();
  }

  const handleclosescaning = () => {
    setencryptedText("");
    setUniqueIds("");
    setDetails(null);
    setMessageLeft("");
    setMessageLefterror("");
    setMessageNew("");
    setMessageNewError("");
    setIsScanning(false);
    // Reset buttons when closing scanner
    resetButtons();
  };

  // Function to reset buttons to initial position
  const resetButtons = () => {
    setDragPositionLeft(0);
    setDragPositionRight(0);
  };

  const toggleModal = () => {
    setIsOpen(!isOpen);
    // Reset buttons when opening/closing main modal
    if (!isOpen) {
      resetButtons();
    }
  };

  useEffect(() => {
    if (uniqueIds) {
      setIsOpen(true);
      setIsScanning(false)
      handleRequestLocation()
      // Reset buttons when modal opens with new QR scan
      resetButtons();
    }
  }, [uniqueIds]);

  // Draggable button functions
  const handleMouseDownLeft = (e) => {
    setIsDraggingLeft(true);
    e.preventDefault();
  };

  const handleMouseDownRight = (e) => {
    setIsDraggingRight(true);
    e.preventDefault();
  };

  const handleMouseMove = (e) => {
  if (!isDraggingLeft && !isDraggingRight) return;

  // ✅ Get clientX for both mouse and touch
  const clientX =
    e.type.includes("touch") && e.touches.length > 0
      ? e.touches[0].clientX
      : e.clientX;

  if (isDraggingLeft && leftButtonRef.current) {
    const buttonRect = leftButtonRef.current.getBoundingClientRect();
    const dragX = clientX - buttonRect.left;
    const maxDrag = buttonRect.width - 40;
    const newPosition = Math.max(0, Math.min(dragX, maxDrag));
    setDragPositionLeft(newPosition);

    if (newPosition >= maxDrag - 5) {
      setIsDraggingLeft(false);
      triggerLeftAction();
    }
  }

  if (isDraggingRight && rightButtonRef.current) {
    const buttonRect = rightButtonRef.current.getBoundingClientRect();
    const dragX = buttonRect.right - clientX;
    const maxDrag = buttonRect.width - 40;
    const newPosition = Math.max(0, Math.min(dragX, maxDrag));
    setDragPositionRight(newPosition);

    if (newPosition >= maxDrag - 5) {
      setIsDraggingRight(false);
      triggerRightAction();
    }
  }
};

  const handleMouseUp = () => {
    // NO AUTO-RESET - Circles stay exactly where user left them
    setIsDraggingLeft(false);
    setIsDraggingRight(false);
  };

  const triggerLeftAction = () => {
    setMoveRight(true);
    setTimeout(() => {
      setIsModalOpen(true);
      setLoading(true);
      setMessageLeft("");
      setMessageLefterror("");
      leftscan();
      setTimeout(() => {
        setMoveRight(false);
      }, 100);
    }, 300);
  };

  const triggerRightAction = () => {
    setMoveLeft1(true);
    setTimeout(() => {
      setIsModalOpen3(true);
      setLoading(true);
      setMessageNew("");
      setMessageNewError("");
      setDetails(null);
      newScan();
      setTimeout(() => {
        setMoveLeft1(false);
      }, 100);
    }, 300);
  };

  // Add event listeners for dragging
 useEffect(() => {
  document.addEventListener("mousemove", handleMouseMove);
  document.addEventListener("mouseup", handleMouseUp);
  document.addEventListener("touchmove", handleMouseMove, { passive: false });
  document.addEventListener("touchend", handleMouseUp);

  return () => {
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
    document.removeEventListener("touchmove", handleMouseMove);
    document.removeEventListener("touchend", handleMouseUp);
  };
}, [isDraggingLeft, isDraggingRight]);

  const handleAllmodelclose1 = () => {
    setIsModalOpen(false);
    setMessageLeft("");
    setMessageLefterror("");
    setLoading(false);
    setIsOpen(false)
    setIsScanning(true)
    setencryptedText("")
    setUniqueIds("")
    setDetails(null)
    // Reset buttons when closing modal
    resetButtons();
  };

  const handleAllmodelclose2 = () => {
    setencryptedText("")
    setUniqueIds("")
    setDetails(null)
    setIsScanning(true)
    setIsModalOpen3(false)
    setIsOpen(false)
    // Reset buttons when closing modal
    resetButtons();
  }

  useEffect(() => {
    AOS.init({ duration: 1500, once: true });

    const loader = document.getElementById("preloader");
    if (loader) {
      setTimeout(() => {
        loader.style.display = "none";

        if (window.$ && window.$("#screen_slider").owlCarousel) {
          window.$("#screen_slider").owlCarousel({
            loop: true,
            margin: 10,
            nav: true,
            dots: true,
            autoplay: true,
            autoplayTimeout: 2500,
            autoplaySpeed: 1000,
            autoplayHoverPause: true,
            center: true,
            stagePadding: 50,
            responsive: {
              0: { items: 1, stagePadding: 30 },
              600: { items: 3, stagePadding: 50 },
              1000: { items: 5, stagePadding: 80 }
            }
          });
        }

        AOS.refresh();
      }, 1000);
    }
  }, []);

  return (
    <>
      <div>
        <div>
          <div className="page_wrapper">
            <div id="preloader">
              <div id="loader" />
            </div>
            <header>
              <div className="container">
                <nav className="navbar navbar-expand-lg">
                  <Link to={"/"} className="navbar-brand" >
                    <img src="images/Logosmall.png" style={{ margin: "auto" }} alt="image" />
                    <div className=" banner_text">
                      <h2 style={{ "marginTop": "0", marginLeft: "0px", fontSize: "14px" }}>
                        Buy original with <span>OriVeri </span>
                      </h2>
                    </div>
                  </Link>
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon">
                      <div className="toggle-wrap">
                        <span className="toggle-bar" />
                      </div>
                    </span>
                  </button>
                  <div
                    className="collapse navbar-collapse"
                    id="navbarSupportedContent">
                    <ul className="navbar-nav ml-auto">
                      <li className="nav-item has_dropdown">
                        <Link to={"/"} className="nav-link" >
                          Home
                        </Link>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="#how_it_work">
                          How it works
                        </a>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </header>

            <section style={{
              padding: "60px 20px",
              background: "#F6F4FE",
              minHeight: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
            }}>
              <div style={{
                display: "flex",
                gap: "60px",
                alignItems: "center",
                maxWidth: "1100px",
                width: "100%",
                flexWrap: "wrap",
                justifyContent: "center"
              }}>
                <div style={{
                  flex: "1",
                  minWidth: "300px",
                  maxWidth: "500px",
                  color: "#2D3748",
                  padding: "20px"
                }}>
                  <h1 style={{
                    fontSize: "clamp(2rem, 4vw, 3rem)",
                    fontWeight: "800",
                    marginBottom: "20px",
                    lineHeight: "1.2",
                    color: "#3a8524"
                  }}>
                    Verify Authentic with{" "}
                    <span style={{
                      color: "#ebd201",
                      background: "linear-gradient(135deg, #ebd201, #ffed4e)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      textShadow: "0 2px 8px rgba(235, 210, 1, 0.2)"
                    }}>
                      OriVeri
                    </span>
                  </h1>

                  <p style={{
                    fontSize: "clamp(1rem, 2vw, 1.2rem)",
                    color: "#4A5568",
                    marginBottom: "30px",
                    lineHeight: "1.6"
                  }}>
                    Scan QR codes to verify product authenticity instantly and protect against counterfeiting.
                  </p>

                  <div style={{ marginBottom: "30px" }}>
                    {[
                      { text: "Instant verification", desc: "Get results in seconds" },
                      { text: "Anti-counterfeit protection", desc: "Secure your brand identity" },
                      { text: "Real-time results", desc: "Live verification process" }
                    ].map((feature, index) => (
                      <div key={index} style={{
                        display: "flex",
                        alignItems: "flex-start",
                        marginBottom: "20px",
                        padding: "15px",
                        background: "rgba(106, 73, 242, 0.05)",
                        borderRadius: "12px",
                        border: "1px solid rgba(106, 73, 242, 0.1)"
                      }}>
                        <div style={{
                          width: "24px",
                          height: "24px",
                          background: "rgb(58, 133, 36)",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "15px",
                          flexShrink: 0,
                          marginTop: "2px"
                        }}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="white">
                            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
                          </svg>
                        </div>
                        <div>
                          <div style={{
                            fontSize: "1rem",
                            fontWeight: "600",
                            color: "#2D3748",
                            marginBottom: "4px"
                          }}>{feature.text}</div>
                          <div style={{
                            fontSize: "0.85rem",
                            color: "#718096"
                          }}>{feature.desc}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div style={{
                  flex: "1",
                  display: "flex",
                  justifyContent: "center",
                 width: "100%"
                }}>
                  <div style={{
                    background: "white",
                    borderRadius: "24px",
                    padding: "10px",
                    boxShadow: "0 20px 40px rgba(106, 73, 242, 0.15)",
                    width: "100%",
                    border: "1px solid rgba(106, 73, 242, 0.1)"
                  }}>

                    <div style={{
                      textAlign: "center",
                      marginBottom: "30px"
                    }}>
                      <span style={{
                        fontSize: "1.0rem",
                        fontWeight: "600",
                        color: "rgb(58, 133, 36)",
                        marginBottom: "8px"
                      }}>Tap below and scan the QR on the product, to complete the Verification
                      </span>
                    </div>

                    <div style={{
                      position: "relative",
                      marginBottom: "25px"
                    }}>

                      {!isScanning ? (
                        <div
                          onClick={handlecameraOpen}
                          style={{
                            width: "100%",
                            height: "280px",
                            background: "linear-gradient(135deg, #F6F4FE, #EDE9FE)",
                            borderRadius: "18px",
                            border: "3px dashed #DDD6FE",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            position: "relative",
                            overflow: "hidden",
                            gap: "15px"
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.borderColor = "#6A49F2";
                            e.currentTarget.style.background = "linear-gradient(135deg, #EDE9FE, #E4E4E7)";
                            e.currentTarget.style.transform = "translateY(-2px)";
                            e.currentTarget.style.boxShadow = "0 10px 30px rgba(106, 73, 242, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.borderColor = "#DDD6FE";
                            e.currentTarget.style.background = "linear-gradient(135deg, #F6F4FE, #EDE9FE)";
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div style={{
                            width: "80px",
                            height: "80px",
                            background: "linear-gradient(135deg, #6A49F2, #8B5CF6)",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          
                            boxShadow: "0 8px 20px rgba(106, 73, 242, 0.3)"
                          }}>
                            <svg width="35" height="35" viewBox="0 0 24 24" fill="white">
                              <path d="M4,4H8V2H4A2,2 0 0,0 2,4V8H4V4M20,4V8H22V4A2,2 0 0,0 20,2H16V4H20M4,16H2V20A2,2 0 0,0 4,22H8V20H4V16M22,16V20H20V22H20L22,20H22V16M9,7V17H15V7H9M11,9H13V15H11V9Z" />
                            </svg>
                          </div>

                          <span style={{
                            fontSize: "1.1rem",
                            fontWeight: "600",
                            color: "rgb(58, 133, 36)",
                            
                          }}>Tap to Start Scanning</span>

                          <span style={{
                            fontSize: "0.85rem",
                            color: "#718096",
                            textAlign: "center",
                            padding: "0 20px",
                            lineHeight: "1.4"
                          }}>Position your camera to scan the OriVeri QR code</span>
                        </div>
                      ) : (
                        <div style={{
                          position: "relative",
                          borderRadius: "18px",
                          overflow: "hidden",
                          height: "280px",
                          boxShadow: "0 10px 30px rgba(106, 73, 242, 0.2)",
                          width: "100%"
                        }}>
                          <BarcodeScannerComponent
                            width="100%"
                            height="100%"
                            onUpdate={(err, result) => {
                              if (result) {
                                const newEncryptedText = decodeURIComponent(
                                  result.text.match(/id=([^&]+)/)?.[1] || ""
                                );
                                if (newEncryptedText !== encryptedText) {
                                  setencryptedText(newEncryptedText);
                                }
                              }
                            }}
                          />

                          <div style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "180px",
                            height: "180px",
                            border: "3px solid rgba(106, 73, 242, 0.8)",
                            borderRadius: "12px",
                            pointerEvents: "none",
                            animation: "pulse 2s infinite"
                          }}></div>

                          <button
                            onClick={handleclosescaning}
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "8px",
                              background: "linear-gradient(135deg, #EF4444, #DC2626)",
                              color: "white",
                              border: "none",
                              borderRadius: "25px",
                              padding: "10px 18px",
                              fontSize: "13px",
                              fontWeight: "600",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              boxShadow: "0 6px 20px rgba(239, 68, 68, 0.3)",
                              transition: "all 0.3s ease",
                              zIndex: "10"
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "scale(1.05)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "scale(1)";
                            }}
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
                              <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                            </svg>
                            Close Scanner
                          </button>
                        </div>
                      )}
                    </div>

                    {/* {encryptedText && (
                      <div style={{
                        background: "linear-gradient(135deg, #10B981, #059669)",
                        color: "white",
                        padding: "18px",
                        borderRadius: "14px",
                        textAlign: "center",
                        marginBottom: "20px",
                        boxShadow: "0 8px 25px rgba(16, 185, 129, 0.3)",
                        animation: "slideUp 0.5s ease-out"
                      }}>
                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "10px",
                          marginBottom: "6px"
                        }}>
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
                          </svg>
                          <span style={{
                            fontSize: "1.1rem",
                            fontWeight: "700"
                          }}>Product Verified Successfully!</span>
                        </div>
                        <p style={{
                          fontSize: "0.9rem",
                          opacity: "0.9",
                          margin: "0",
                          lineHeight: "1.4"
                        }}>This is an authentic OriVeri protected product</p>
                      </div>
                    )} */}

                    <div style={{
                      background: "#F6F4FE",
                      padding: "18px",
                      borderRadius: "14px",
                      border: "1px solid #DDD6FE"
                    }}>
                      <h4 style={{
                        fontSize: "0.95rem",
                        fontWeight: "600",
                        color: "rgb(45, 55, 72)",
                        marginBottom: "10px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px"
                      }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="rgb(45, 55, 72)">
                          <path d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                        </svg>
                        How to Scan
                      </h4>
                      <ol style={{
                        color: "#6B7280",
                        fontSize: "0.85rem",
                        lineHeight: "1.6",
                        paddingLeft: "20px",
                        margin: "0"
                      }}>
                        <li>Click the scanner area above</li>
                        <li>Allow camera permissions in your browser</li>
                        <li>Point your camera at the QR code</li>
                        <li>Hold steady for automatic detection</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>

              <style jsx>{`
                @keyframes pulse {
                  0% { opacity: 0.7; transform: translate(-50%, -50%) scale(1); }
                  50% { opacity: 1; transform: translate(-50%, -50%) scale(1.02); }
                  100% { opacity: 0.7; transform: translate(-50%, -50%) scale(1); }
                }
                
                @keyframes slideUp {
                  from { 
                    transform: translateY(20px); 
                    opacity: 0; 
                  }
                  to { 
                    transform: translateY(0); 
                    opacity: 1; 
                  }
                }

                @media (max-width: 768px) {
                  div {
                    gap: 15px !important;
                    flex-direction: column-reverse;
                  }
                }
              `}</style>
            </section>

            <section className="row_am how_it_works" id="how_it_work">
              <div className="container">
                <div className="how_it_inner">
                  <div
                    className="section_title"
                    data-aos="fade-up"
                    data-aos-duration={1500}
                    data-aos-delay={300}>
                    <h2>
                      <span>How it works</span> - 3 easy steps
                    </h2>
                    <p>
                      Our platform makes is super easy to identify Counterfeits,
                      Expired or already Sold Products
                    </p>
                  </div>
                  <div className="step_block">
                    <ul>
                      <li>
                        <div
                          className="step_text"
                          data-aos="fade-right"
                          data-aos-duration={1500}>
                          <h4>Download app</h4>
                          <div className="app_icon">
                            <a href="#">
                              <i className="icofont-brand-android-robot" />
                            </a>
                            <a href="#">
                              <i className="icofont-brand-apple" />
                            </a>
                          </div>
                          <p>Download App either for Android or IOS</p>
                          <p>
                            Sign up free using your moblie number and email ID
                          </p>
                        </div>
                        <div className="step_number">
                          <h3>01</h3>
                        </div>
                        <div
                          className="step_img"
                          data-aos="fade-left"
                          data-aos-duration={1500}>
                          <img src="images/download_app.jpg" alt="image" />
                        </div>
                      </li>
                      <li>
                        <div
                          className="step_text"
                          data-aos="fade-left"
                          data-aos-duration={1500}>
                          <h4>Swipe </h4>
                          <p>
                            {" "}
                            Or just Swpie left to know if the product is right !
                          </p>
                        </div>
                        <div className="step_number">
                          <h3>02</h3>
                        </div>
                        <div
                          className="step_img"
                          data-aos="fade-right"
                          data-aos-duration={1500}>
                          <img src="images/create_account.jpg" alt="image" />
                        </div>
                      </li>
                      <li>
                        <div
                          className="step_text"
                          data-aos="fade-right"
                          data-aos-duration={1500}>
                          <h4>Get Results Instantly </h4>
                          <p>
                            To get complet details of the product you are buying{" "}
                          </p>
                        </div>
                        <div className="step_number">
                          <h3>03</h3>
                        </div>
                        <div
                          className="step_img"
                          data-aos="fade-left"
                          data-aos-duration={1500}>
                          <img src="images/enjoy_app.jpg" alt="image" />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            <section class="row_am interface_section">
              <div class="container-fluid">
                <div
                  class="section_title"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                  data-aos-delay="300">
                  <h2>
                    Effective and <span>Efficient Interface</span>
                  </h2>
                </div>

                <div className="screen_slider">
                  <div
                    id="screen_slider"
                    className="owl-carousel owl-theme owl-loaded owl-drag">
                    <div className="item" >
                      <div className="screen_frame_img">
                        <img width={250} src="images/screen-1.png" alt="image" />
                      </div>
                    </div>
                    <div className="item">
                      <div className="screen_frame_img">
                        <img width={250} src="images/screen-3.png" alt="image" />
                      </div>
                    </div>
                    <div className="item">
                      <div className="screen_frame_img">
                        <img width={250} src="images/screen-4.jpg" alt="image" />
                      </div>
                    </div>
                    <div className="item">
                      <div className="screen_frame_img">
                        <img width={250} src="images/screen-5.jpg" alt="image" />
                      </div>
                    </div>
                    <div className="item">
                      <div className="screen_frame_img">
                        <img width={250} src="images/screen-6.jpg" alt="image" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <footer>
              <div className="top_footer" id="contact">
                <div className="anim_line dark_bg">
                  <span>
                    <img src="images/anim_line.png" style={{ margin: "auto" }} alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" style={{ margin: "auto" }} alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" style={{ margin: "auto" }} alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" style={{ margin: "auto" }} alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" style={{ margin: "auto" }} alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" style={{ margin: "auto" }} alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" style={{ margin: "auto" }} alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" style={{ margin: "auto" }} alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" style={{ margin: "auto" }} alt="anim_line" />
                  </span>
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="abt_side">
                        <div className="logo">
                          <img src="images/Logosmall.png" style={{ margin: "auto" }} alt="image" />
                        </div>
                        <ul>
                          <li>
                            <a href="#">info@oriveri.com</a>
                          </li>
                        </ul>
                        <ul className="social_media">
                          <li>
                            <a href="#">
                              <i className="icofont-facebook" />
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i className="icofont-linkedin" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="links">
                        <ul>
                          <li>
                            <Link to="/contactowner" style={{ color: "yellow", fontWeight: "bold" }}>
                              For Brand Owners
                            </Link>
                          </li>
                          <li>
                            <Link to="/scanqr" style={{ color: "yellow", fontWeight: "bold" }}>
                              Scan Qr
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="links">
                        <ul>
                          <li>
                            <Link to="/contact">Contact us</Link>
                          </li>
                          <li>
                            <Link to="/terms&conditions">Terms &amp; conditions</Link>
                          </li>
                          <li>
                            <Link to="/privacy">Privacy policy</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <div className="try_out">
                        <div
                          style={{ borderRadius: "10px 10px 0px 0px" }}
                          className="responsive_div"
                        >
                          <h4 className="responsive_heading">
                            <b>Download</b> the <b>Application</b> for a{" "}
                            <b>Secured</b>, <b>Swift</b>, and <b>Smooth experience</b>!
                          </h4>
                          <ul style={{ marginBottom: "0px" }} className="app_btn">
                            <li>
                              <a href="https://apps.apple.com/us/app/oriveri/id6741198221">
                                <img src="images/appstore_blue.png" alt="App Store" />
                              </a>
                            </li>
                            <li>
                              <a href="https://play.google.com/store/apps/details?id=com.oriveri.com">
                                <img
                                  style={{ padding: "3px" }}
                                  src="images/googleplay_blue.png"
                                  alt="Google Play"
                                />
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bottom_footer">
                <div className="container">
                  <div className="row">
                    <div className="col-md-6">
                      <p>© Copyrights 2025. All rights reserved.</p>
                    </div>
                    <div className="col-md-6">
                      <p className="developer_text">
                        Design &amp; developed by{" "}
                        <a
                          href="https://themeforest.net/user/kalanidhithemes"
                          target="blank">
                          Logical Softtech Pvt. Ltd.
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="go_top">
                <span>
                  <img src="images/go_top.png" alt="image" />
                </span>
              </div>
            </footer>

            <div
              className="modal fade youtube-video"
              id="myModal"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="myModalLabel">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <button
                    id="close-video"
                    type="button"
                    className="button btn btn-default text-right"
                    data-dismiss="modal">
                    <i className="icofont-close-line-circled" />
                  </button>
                  <div className="modal-body">
                    <div id="video-container" className="video-container">
                      <iframe
                        id="youtubevideo"
                        src="#"
                        width={640}
                        height={360}
                        frameBorder={0}
                        allowFullScreen
                      />
                    </div>
                  </div>
                  <div className="modal-footer"></div>
                </div>
              </div>
            </div>
            <div className="purple_backdrop" />
          </div>
        </div>
      </div>

      {/* First Modal with Draggable Buttons - COMPLETELY FIXED */}
      {isOpen && (
        <div className="modal show d-block" >
          <div style={{ width: "95%", margin: "auto" }} className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Thank You for Scanning the OriVeri QR</h5>
                <button type="button" className="close" onClick={toggleModal}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="container mt-4">
                  <div className="row">
                    <div style={{ marginBottom: "50px" }} className="w-100 d-flex align-center justify-content-center ">
                      <img width={180} src="images/Logosmall.png" style={{ margin: "auto" }} alt="Logo" />
                    </div>
                    <div
                      className="button-container w-100 d-flex align-center justify-content-center"
                      style={{ gap: "20px" }}
                    >
                      {/* Left Button - Just Checking (Left to Right) */}
                      <div
                        ref={leftButtonRef}
                        style={{
                          position: "relative",
                          width: "220px",
                          height: "50px",
                          backgroundColor: "#ffd34f",
                          borderRadius: "25px",
                          cursor: "pointer",
                          overflow: "hidden",
                          userSelect: "none"
                        }}
                        onMouseDown={handleMouseDownLeft}
                        onTouchStart={handleMouseDownLeft}
                      >
                        <div
                          style={{
                            position: "absolute",
                            left: `${dragPositionLeft}px`,
                            top: "5px",
                            width: "40px",
                            height: "40px",
                            backgroundColor: "#fcee00",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: isDraggingLeft ? "none" : "left 0.3s ease",
                            boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
                          }}
                        >
                          <FaAnglesRight style={{ color: "#333" }} />
                        </div>
                        <span
                          style={{
                            position: "absolute",
                            left: "50px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#333",
                            fontWeight: "bold",
                            fontSize: "14px"
                          }}
                        >
                          Just Checking
                        </span>
                      </div>

                      {/* Right Button - Checking to Buy (Right to Left) */}
                      <div
                        ref={rightButtonRef}
                        style={{
                          position: "relative",
                          width: "220px",
                          height: "50px",
                          backgroundColor: "#329347",
                          borderRadius: "25px",
                          cursor: "pointer",
                          overflow: "hidden",
                          userSelect: "none"
                        }}
                        onMouseDown={handleMouseDownRight}
                        onTouchStart={handleMouseDownRight}
                      >
                        <div
                          style={{
                            position: "absolute",
                            right: `${dragPositionRight}px`,
                            top: "5px",
                            width: "40px",
                            height: "40px",
                            backgroundColor: "#005e12",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: isDraggingRight ? "none" : "right 0.3s ease",
                            boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
                          }}
                        >
                          <FaAnglesLeft style={{ color: "white" }} />
                        </div>
                        <span
                          style={{
                            position: "absolute",
                            left: "50px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "white",
                            fontWeight: "bold",
                            fontSize: "14px"
                          }}
                        >
                          Checking to Buy
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Second Modal */}
      {isModalOpen && (
        <div className="modal show d-block" style={{ width: "100%" }}>
          <div style={{ width: "95%", margin: "auto" }} className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" onClick={() => setIsModalOpen(false)}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="w-100 d-flex align-center justify-content-center mb-4">
                  <img width={150} src="images/Logosmall.png" style={{margin: "auto"}} alt="Logo" />
                </div>
                <div className="container mt-4">
                  <div className="row">
                    {loading && !messageLeft && !messageLefterror && (
                      <div className="w-100 d-flex align-center justify-content-center mb-4">
                        <div className="text-center">
                          <div className="spinner-border text-primary mb-3" role="status" />
                          <h5>Loading, please wait...</h5>
                        </div>
                      </div>
                    )}

                    {!loading && messageLeft && (
                      <>
                        <div className="w-100 d-flex align-center justify-content-center mb-4">
                          <img width={90} src="images/favicon.png" style={{margin: "auto"}} alt="Logo" />
                        </div>
                        <div className="w-100 d-flex align-center justify-content-center mb-4">
                          <h5 style={{ color: "#3a8524" }}>{messageLeft}</h5>
                        </div>
                      </>
                    )}

                    {!loading && messageLefterror && (
                      <>
                        <div className="w-100 d-flex align-center justify-content-center mb-4">
                          <img width={90} src="images/wrong.gif" style={{margin: "auto"}} alt="Logo" />
                        </div>
                        <div className="w-100 d-flex align-center justify-content-center mb-4">
                          <h5 style={{ color: "rgb(252 21 0)" }}>{messageLefterror}</h5>
                        </div>
                      </>
                    )}

                    <div className="button-container3 w-100 d-flex align-center justify-content-center mb-4">
                      <button
                        onClick={handleAllmodelclose1}
                        type="button"
                        className="btn p-3 rounded-pill responsive-btn3"
                      >
                        Scan Again
                      </button>
                      <button
                        onClick={handleclose2}
                        className="btn p-3 rounded-pill responsive-btn3"
                      >
                        Done
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Third Modal */}
      {isModalOpen3 && (
        <div className="modal show d-block" style={{ width: "100%" }}>
          <div style={{ width: "95%", margin: "auto" }} className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" onClick={() => setIsModalOpen3(false)}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="w-100 d-flex align-items-center justify-content-center mb-4">
                  <img width={150} src="images/Logosmall.png" style={{margin: "auto"}}  alt="Logo" />
                </div>

                {loading ? (
                  <div className="w-100 d-flex align-items-center justify-content-center mb-4">
                    <div className="text-center">
                      <div className="spinner-border text-primary mb-3" role="status" />
                      <h5>Loading, please wait...</h5>
                    </div>
                  </div>
                ) : details && Array.isArray(details) && details.length > 0 ? (
                  <div className="container-fluid mt-4 p-0 p-sm-2" style={{ padding: "10px" }}>
                    {details.map((item, index) => (
                      <div key={index} className="mb-4 p-0 p-sm-3">
                        <div className="row w-100 align-items-center">
                          <div className="col-6 d-flex justify-content-center">
                            <img
                              width={120}
                              className="rounded p-3"
                              src={item?.image_link || "images/abt_02.png"}
                              alt="Product"
                              style={{ borderRadius: "10px" }}
                            />
                          </div>
                          <div className="col-6 d-flex flex-column justify-content-center text-center text-md-end">
                            <p className="mb-0"><strong>{item?.brand}</strong></p>
                            <p className="mb-0"><strong>{item?.product}</strong></p>
                          </div>
                        </div>

                        <div className="row w-100 align-items-center">
                          <div className="col-6 text-center text-md-start">
                            <p className="mb-0"><strong>{item?.batch_name}</strong></p>
                          </div>
                          <div className="col-6 text-center text-md-end">
                            <p className="mb-0"><strong>{item?.price}</strong></p>
                          </div>
                        </div>

                        <div className="row w-100 align-items-center">
                          <div className="col-6 text-center text-md-start">
                            <p className="mb-0"><strong>{item?.other_one}</strong></p>
                          </div>
                          <div className="col-6 text-center text-md-end">
                            <p className="mb-0"><strong>{item?.other_two}</strong></p>
                          </div>
                        </div>
                      </div>
                    ))}

                    <div className="button-container3 w-100 d-flex align-center justify-content-center mb-4">
                      <button onClick={handleAllmodelclose2} type="button" className="btn p-3 rounded-pill responsive-btn3">
                        Scan Again
                      </button>
                      <button onClick={handleclose3} className="btn p-3 rounded-pill responsive-btn3">
                        Done
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="container mt-4">
                    <div className="row">
                      {messageNew && (
                        <>
                          <div className="w-100 d-flex align-items-center justify-content-center mb-4">
                            <img width={90} src="images/favicon.png" style={{margin: "auto"}} alt="Success" />
                          </div>
                          <div className="w-100 d-flex align-items-center justify-content-center mb-4">
                            <h5 style={{ color: "#3a8524" }}>{messageNew}</h5>
                          </div>
                        </>
                      )}

                      {messageNewError && (
                        <>
                          <div className="w-100 d-flex align-items-center justify-content-center mb-4">
                            <img width={90} src="images/wrong.gif" style={{margin: "auto"}} alt="Error" />
                          </div>
                          <div className="w-100 d-flex align-items-center justify-content-center mb-4">
                            <h5 style={{ color: "rgb(252, 21, 0)" }}>{messageNewError}</h5>
                          </div>
                        </>
                      )}

                      <div className="button-container3 w-100 d-flex align-items-center justify-content-center mb-4">
                        <button onClick={handleAllmodelclose2} className="btn p-3 rounded-pill responsive-btn3">
                          Scan Again
                        </button>
                        <button onClick={handleclose3} className="btn p-3 rounded-pill responsive-btn3">
                          Done
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Home;